import { render, staticRenderFns } from "./MaterialGetView.vue?vue&type=template&id=16b0b24a"
import script from "./MaterialGetView.vue?vue&type=script&lang=js"
export * from "./MaterialGetView.vue?vue&type=script&lang=js"
import style0 from "./MaterialGetView.vue?vue&type=style&index=0&id=16b0b24a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports